"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareLocalizedAsset = void 0;
const messaging_common_1 = require("@guided-methods/messaging-common");
const React = __importStar(require("react"));
const client_1 = require("react-dom/client");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("./components");
const services_1 = require("./services");
const env_resolver_1 = require("./services/env-resolver");
const setup_1 = require("./setup");
require("bootstrap/dist/css/bootstrap.min.css");
const flat_1 = require("flat");
const react_intl_1 = require("react-intl");
require("./index.css");
const get_library_assets_service_1 = require("./services/get-library-assets-service");
require("./tailwind.css");
let startTime = new Date();
const tokenService = new services_1.TokenService();
let defaultOptions = {
    rootChannelId: "",
    runnerId: "",
    messageUrl: (0, env_resolver_1.getGuideMessageGatewayByEnv)(),
    signalrHubUrl: (0, env_resolver_1.getSignalRHubUrlByEnv)(),
    guideRequestServiceUrl: (0, env_resolver_1.getGuideRequestServiceByEnv)(),
    registryUrl: (0, env_resolver_1.getRegistryByEnv)(),
    bucketUrl: (0, env_resolver_1.getGuideViewsBucketUrlByEnv)(),
    storageUrl: (0, env_resolver_1.getGuideStorageByEnv)(),
    loggingServiceUrl: (0, env_resolver_1.getLoggingServiceByEnv)(),
    operationProvisionerUrl: (0, env_resolver_1.getOperationProvisionerUrlByEnv)(),
    guideDiscoveryUrl: (0, env_resolver_1.getGuideDiscoveryUrlByEnv)(),
    operationResolverUrl: (0, env_resolver_1.getOperationResolverUrlByEnv)(),
    wcsUrl: (0, env_resolver_1.getWcsUrlByEnv)(),
    appName: 'sws-guide-host-app',
    appVersion: APP_VERSION,
    tokenService,
    testMode: false,
    requestId: "",
    router: (0, messaging_common_1.router)()
};
const messageLog = process.env.TEST_MODE === 'dev' ? new services_1.MessageLog() : undefined;
let customOptions = defaultOptions;
if (process.env.TEST_MODE === 'dev') {
    customOptions = {
        ...defaultOptions,
        messageTracker: messageLog?.push.bind(messageLog),
    };
}
const prepareLocalizedAsset = (fullLocaleId, assets) => {
    if (!fullLocaleId || fullLocaleId === '') {
        throw new Error('fullLocaleId not provided');
    }
    let language = fullLocaleId.split(/[-_]/)[0];
    return { language, messages: { [language]: (0, flat_1.flatten)(assets) } };
};
exports.prepareLocalizedAsset = prepareLocalizedAsset;
const options = (0, setup_1.applyDefaults)(customOptions);
let matches = window.location.href.match(/^.*?.*lang=([^&]*).*$/);
let fullLocaleId = matches && matches.length > 1 ? matches[1] : navigator.language;
const sources = [
    { repoName: 'sws-guide-host-app', assetPath: 'assets/gui-strings.json' },
    { repoName: 'sws-guide-ts-packages', assetPath: 'tds/assets/gui-strings.json' },
];
const ignoreDefaultMessageError = (error) => {
    if (typeof error.message === 'string' &&
        error.message.includes('[@formatjs/intl Error MISSING_TRANSLATION]')) {
        console.warn(error.message);
    }
};
let failuresBeforeLogger = [];
let props;
try {
    props = (0, exports.prepareLocalizedAsset)(fullLocaleId, {});
}
catch (e) {
    const msg = `Failed to prepare localized assets for '${fullLocaleId}'`;
    failuresBeforeLogger.push(msg);
    console.error(msg);
}
(0, get_library_assets_service_1.getLibraryAssets)(sources, props?.language ?? "en-GB", fullLocaleId)
    .catch((e) => {
    const msg = `Failed to load localized assets for '${fullLocaleId}': ${e?.message}`;
    failuresBeforeLogger.push(msg);
})
    .then((config) => {
    const rootEl = document.getElementById('root');
    const root = (0, client_1.createRoot)(rootEl);
    const locale = config?.language ?? "";
    const messages = config?.messages ? config.messages[locale] : undefined;
    root.render(React.createElement(react_router_dom_1.BrowserRouter, null,
        React.createElement(react_router_dom_1.Routes, null,
            React.createElement(react_router_dom_1.Route, { path: "/callback", element: React.createElement(components_1.Callback, { tokenService: tokenService, silent: false }) }),
            React.createElement(react_router_dom_1.Route, { path: "/silent-renew-callback", element: React.createElement(components_1.Callback, { tokenService: tokenService, silent: true }) }),
            React.createElement(react_router_dom_1.Route, { element: React.createElement(react_router_dom_1.Navigate, { to: "/", replace: true }) }),
            React.createElement(react_router_dom_1.Route, { path: "/runner/:runnerId", handle: console.log("Routing..."), element: getMainContent(locale, messages) }),
            React.createElement(react_router_dom_1.Route, { path: "/:requestId?", element: getMainContent(locale, messages) }))));
})
    .catch((e) => {
    console.error("Unexpected error on startup. Aborting.");
});
function getMainContent(locale, messages) {
    return React.createElement(react_intl_1.IntlProvider, { locale: locale, messages: messages, defaultLocale: locale, key: locale, onError: ignoreDefaultMessageError },
        React.createElement(components_1.Authenticated, { tokenService: tokenService },
            React.createElement(components_1.App, { launcher: async (runnerId, requestId) => {
                    let services;
                    const { rootChannelId } = services?.hostServices ?? {};
                    try {
                        services = await (0, setup_1.setupServices)(options);
                    }
                    catch (e) {
                        console.error(e);
                        failuresBeforeLogger.push((e instanceof Error) ? e?.message : "Failed to setup services");
                    }
                    if (!services || services?.logger === undefined) {
                        const message = "Failed to setup logging. Cannot proceed. Aborting.";
                        console.error(message);
                        throw new Error(message);
                    }
                    const logTemplate = {
                        message: ``,
                        rootChannelId,
                        mode: messaging_common_1.LogMode.Framework,
                        layer: "HostSetup",
                    };
                    services.logger.info({ ...logTemplate, message: `Guide host app started` });
                    if (failuresBeforeLogger.length > 0) {
                        failuresBeforeLogger.forEach(message => {
                            if (services.logger) {
                                services?.logger.error({ ...logTemplate, message });
                            }
                        });
                    }
                    if (services?.hostServices == undefined) {
                        const message = "Uncoverable error setting up host-app. Aborting.";
                        services.logger.error({ ...logTemplate, message });
                        throw new Error(message);
                    }
                    try {
                        (0, setup_1.setupRouting)(services.hostServices);
                        const endTime = +new Date() - +startTime;
                        services.logger.info({
                            ...logTemplate,
                            message: `Host loaded in ${endTime} ms`,
                            layer: messaging_common_1.LogLayerNames.Performance,
                            executionDuration: endTime,
                        });
                    }
                    catch (err) {
                        services.logger.error({ ...logTemplate, message: 'Failed to setup routing' });
                    }
                    try {
                        if (requestId)
                            (0, setup_1.startGuideFromRequest)(requestId, options, services.hostServices);
                    }
                    catch (err) {
                        services.logger.error({
                            ...logTemplate,
                            message: 'Failed to start process Request',
                            requestId
                        });
                    }
                    return services.hostServices;
                }, options: options, messageLog: messageLog })));
}
